import { LoadSpinner } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import React, { FC, useMemo } from 'react'

import { Table } from '@/components'
import { RecordType } from '@/graphql/queries/fieldHistoryLogs/fieldHistoryLogs.queries'
import { useFieldHistoryLogs } from '@/hooks/useFieldHistoryLogs/useFieldHistoryLogs'

import { HistoryColumns } from './History.data'

type Props = {
  recordId: number
  recordType: RecordType
}

export const History: FC<Props> = ({ recordId, recordType }) => {
  const { isLoading, fieldChangeRows } = useFieldHistoryLogs({
    record: { id: recordId, recordType },
  })

  const historyColumns = useMemo(() => {
    return HistoryColumns
  }, [])

  return (
    <div className="flex w-full flex-col flex-wrap px-6" style={{ minWidth: '60rem' }}>
      <h3 className="mb-4 text-header-sm">History</h3>
      <HistoryTableStyled className="flex max-h-132 w-full ">
        {isLoading ? (
          <div className="flex h-20 w-full items-center justify-center">
            <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
          </div>
        ) : (
          <Table columns={historyColumns as any} data={fieldChangeRows} />
        )}
      </HistoryTableStyled>
    </div>
  )
}

const HistoryTableStyled = styled.div`
  .table-container {
    overflow: scroll;
  }
`
